import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Header() {
    const navigate = useNavigate();
    const location = useLocation();

    function goHome() {
        navigate('/');
    }

    // 判断是否是首页（路径为 '/'）
    const isHomePage = location.pathname === '/';

    return (
        <header id="header">
            <span className="header-btn-left iconfont icon-sousuo"></span>
            <span className="header-btn-right iconfont icon-home" onClick={goHome}></span>
        </header>
    );
}